import { EventStickerCodes } from 'defs/events';
import { getTargetFromFactory } from 'defs/notifications';
import { TargetTypes } from 'defs/notifications';
import { TargetsType } from 'types/NotificationTargets';

const targets: TargetsType = {
	[EventStickerCodes.S01]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventStickerCodes.S02]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventStickerCodes.S03]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventStickerCodes.S04]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventStickerCodes.S05]: {
		primary: {
			type: TargetTypes.Close,
		},
	},
};

export const get = (key: string) => getTargetFromFactory(targets, key);

export default targets;
